import React from 'react'
import { useCard, CardProps } from './useCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './Card.module.scss'

const Card: React.FC<CardProps> = (props: CardProps) => {
  const { contactSocials, ContactSocial, t } = useCard(props)

  return (
    <div className={styles['contact-card']}>
      <h3>{t('ourInformation')}</h3>
      {contactSocials && contactSocials.length ? (
        contactSocials.map((item, index) => {
          return (
            <div
              key={`social-item-${item.id}-${index}`}
              className={styles.item}
            >
              <div className={styles['icon-box']}>
                {item.name === ContactSocial.Email ? (
                  <FontAwesomeIcon icon={['fas', 'envelope']} />
                ) : item.name === ContactSocial.Phone ? (
                  <FontAwesomeIcon icon={['fas', 'phone']} />
                ) : (
                  <FontAwesomeIcon icon={['fas', 'location-dot']} />
                )}
              </div>
              <div className={styles.content}>
                <p>
                  {item.name === ContactSocial.Email ? (
                    <a href={`mailto:${item.url}`}>{item.displayText}</a>
                  ) : (
                    item.displayText
                  )}
                </p>
              </div>
            </div>
          )
        })
      ) : (
        <div className='col-12 text-center fs-4 fw-bold'>{t('noData')}</div>
      )}
    </div>
  )
}

export default Card
